import { Modal, type TpModalProps } from '@mentalgrowth/ui-kit-web';
import { memo } from 'react';
const UiKitModal = memo((props: TpModalProps) => <Modal {...props} />);
UiKitModal.displayName = 'UiKitModal';
export default UiKitModal;